import {
  TABLE_COL_COUNT_LOCAL_SETTING,
  TABLE_COL_PAGE_COUNT_DEFAULT,
} from '../components/DataSetSettings/ColumnListTable/ColumnList/ColumnList.constants';
import { IDatasourceList, IDataSourceTablesPagination } from '../Datasources.interfaces';

export const dataSourceTablesPaginationInitialState = {
  pageLimit: 10,
  currentPage: 1,
  searchTerm: '',
};

export const studioInitialPath = '/studio/domains';

export const tableColumnsInitialState: ITableColumns = {
  columnInfo: {
    data: [],
    searchCount: 0,
    selectedCount: 0,
    totalCount: 0,

    colCountPerPage: Number(
      localStorage?.getItem(TABLE_COL_COUNT_LOCAL_SETTING) || TABLE_COL_PAGE_COUNT_DEFAULT
    ),
    page: 1,
    paginationCount: 1,
  },
  columnList: [],
  isLoading: false,
  hasError: false,
  errorCode: -1,
  searchStr: '',
};

interface ITableInfo {
  tablesRaw: any;
  hasError: boolean;
  isLoading: boolean;
  totalTables: number;
  tablesIndexedList: any;
  activeTableName: string | null;
  tablesPagination: IDataSourceTablesPagination;
}

export interface IDataSourceTypesResponse {
  name: string;
  id: number;
  connectionUrl: string | null;
  schema?: string;
}
interface IDataSourceTypes {
  typesMap: Record<number, IDataSourceTypesResponse>;
  typesList: IDataSourceTypesResponse[];
  hasError: boolean;
  isLoading: boolean;
  csvTypeIds: number[];
}

export interface ITableColumnData {
  columnName: string;
  selected: boolean;
}

export interface ITableColumnInfo {
  data: ITableColumnData[];
  searchCount: number;
  selectedCount: number;
  totalCount: number;

  // used for pagination
  colCountPerPage: number;
  page: number;
  paginationCount: number;
}

export interface ITableColumns {
  columnInfo: ITableColumnInfo;
  hasError: boolean;
  isLoading: boolean;
  errorCode: number;
  columnList: any;
  searchStr: string;
}

export interface IDataSourceItem {
  dataSourceType: number;
  id: number;
  name: string;
}

export type TCSVDataSourceProps = {
  fileName: string;
  headerRow: string;
  dataRow: string;
  delimiter: string;
};

export type TAPIDataSourceProps = {
  baseURL: string;
  authType: string;
  responseType: string;
};

export type TKobaiAPIDataSourceProps = {
  dataUrl: string;
  xApiKey: string;
};

export type TAzureDataSourceProps = {
  storageAccountUrl: string;
  sasToken: string;
  container: string;
  folder: string;
  filePattern: string;
  region: string;
  headerRow: string;
  dataRow: string;
  delimiter: string;
};

export type TS3CSVDataSourceProps = {
  accessId: string;
  accessSecret: string;
  bucket: string;
  filePattern: string;
  folder: string;
  region: string;
  headerRow: string;
  dataRow: string;
  delimiter: string;
};

export type TDataSource = {
  id: number | null;
  name: string;
  connectionUrl?: null | string;
  userName: string;
  password: string;
  dataSourceType: number;
  schema?: string;
  props: {
    // S3
    accessId?: string;
    accessSecret?: string;
    bucket?: string;
    filePattern?: string;
    folder?: string;
    region?: string;

    // Azure
    storageAccountUrl?: string;
    sasToken?: string;
    container?: string;

    // kobai API
    dataUrl?: string;
    xApiKey?: string;

    // API
    baseURL?: string;
    responseType?: string;
    authType?: string;

    // CSV's
    fileName?: string | null;
    headerRow?: string;
    dataRow?: string;
    delimiter?: string;
  };
  profiles: null | any;
  ingestionSchedule: any[];
};

export interface IDeleteDataSourceProps {
  isConfirmOpen: boolean;
  isDeleting: boolean;
  hasDeleteError: boolean;
  errorMsg: string;
}

export const initialDeleteDataSourceProps: IDeleteDataSourceProps = {
  isConfirmOpen: false,
  isDeleting: false,
  hasDeleteError: false,
  errorMsg: '',
};

export interface IDataSourceState {
  isLoading: boolean;
  hasLoadingError: boolean;
  filterValues: {
    searchTerm: string;
    typeId: number;
  };
  errorCode: number;
  datasourceList: IDatasourceList | null;
  filteredList: IDatasourceList;
  isDataSourcesEmpty: boolean;
  activeDataSourceSelectedColCount: number;
  activeDataSourceTotalCols: number;
  tableInfo: ITableInfo;
  types: IDataSourceTypes;
  tableColumns: ITableColumns;
  previousPath: string;
  deleteDataSourceProps: IDeleteDataSourceProps;
}

export type TDataSourceListTypes = 'used' | 'unUsed';

export const initialDataSourceList = {
  used: [],
  unUsed: [],
};

export const datasourcesInitialState: IDataSourceState = {
  tableInfo: {
    totalTables: 0,
    activeTableName: null,
    isLoading: false,
    hasError: false,
    tablesRaw: [],
    tablesIndexedList: {},
    tablesPagination: dataSourceTablesPaginationInitialState,
  },

  types: {
    isLoading: false,
    hasError: false,
    csvTypeIds: [],
    typesList: [],
    typesMap: {},
  },

  tableColumns: tableColumnsInitialState,

  isLoading: false,
  hasLoadingError: false,
  errorCode: -1,
  datasourceList: null,
  filterValues: {
    searchTerm: '',
    typeId: 0,
  },
  filteredList: initialDataSourceList,
  activeDataSourceSelectedColCount: 0,
  activeDataSourceTotalCols: 0,

  isDataSourcesEmpty: false,
  previousPath: studioInitialPath,
  deleteDataSourceProps: initialDeleteDataSourceProps,
};
